export default __webpack_public_path__ + "static/media/210754.38bef9d8.jpg";